import { useEffect, useRef, useState } from 'react';
import './style.scss'
import { useFormContext } from 'react-hook-form';

interface Props {
    handleClose: (e: boolean) => void,
    values: { label: string, value: string }[],
    storeHistory: (field: string, value: any, type: string) => void;
    setRedoState: (redoState: any) => void;
}

const Popup = ({ handleClose, values, storeHistory }: Props) => {

    const { setValue, watch } = useFormContext()
    const [options, setOptions] = useState<{ label: string, value: string }[]>([])
    const [error, setError] = useState<boolean>(false)

    const textAreaRef = useRef<any>()
    const setOptionValue = (value: string): void => {

        value?.split('\n')?.forEach((optionValue: string, optionIndex: number) => {
            options[optionIndex] = {
                label: optionValue,
                value: optionValue
            }
        })
        setOptions([...options].filter((option) => option.label && option.value))
    }

    const saveValues = (): void => {
        const addedValues = options?.map(option => option?.value)
        const isDuplicateValues = addedValues?.some((value: string) => addedValues?.filter((val: string) => val === value)?.length > 1)
        if (isDuplicateValues) {
            setError(true)
            return
        }
        storeHistory('options', watch('options'), "slides")
        setValue(`options`, options);
        handleClose(false);
    }

    useEffect(() => {
        if (watch('options')?.length) {
            setOptions(watch('options'))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <div className='popup-container'>
            <div className='popup'>
                <div className="popup-content">
                    <div className="dropdown-header">
                        <span className="dropdown-title">Edit choices</span>
                        <span className="dropdown-desc">Write or paste your choices below. Each choice must be on a separate line.</span>
                    </div>
                    <div className='popup-main'>
                        <div className='popup-body'>
                            <textarea ref={textAreaRef} rows={1} defaultValue={values?.map((obj: { value: string; }) => obj?.value)?.join('\n')} aria-label="Your choices go here
                                One per line
                                Like this
                                :-)" placeholder="Your choices go here
                                One per line
                                Like this
                                :-)" className="textarea" onChange={(e: any) => { setOptionValue(e?.target?.value); setError(false) }}></textarea>
                        </div>
                    </div>
                    <div style={{ minHeight: "25px" }}>{error && <em className="error">Duplicate choices are not allowed</em>}</div>
                    <div className="dropdown-footer">
                        <button type="button" className="btn" onClick={() => { handleClose(false); }}>
                            Cancel
                        </button>
                        <button type="button" onClick={() => { saveValues() }} className="btn save">
                            Save choices
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Popup